import { render, staticRenderFns } from "./index.vue?vue&type=template&id=487d39be"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=487d39be&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487d39be')) {
      api.createRecord('487d39be', component.options)
    } else {
      api.reload('487d39be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=487d39be", function () {
      api.rerender('487d39be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/element-dialog/src/index.vue"
export default component.exports